
















import { listFactory } from '@/main/pages/listFactory';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';

import { store } from './store/list';
import { listMutationsNames } from './store/constants';
import { NAME } from './constants';

export default listFactory(NAME, store).extend({
	components: {
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				nakladoveStredisko: `${this.storeUri}/${listMutationsNames.NAKLADOVE_STREDISKO_SELECT_MAPPER}`,
			};
		},
		naklStredFilter() {
			return { ProvozovnaId: this.ProvozovnaId };
		},
	},
});
